module.exports = "<igo-catalog-layers-list igoCatalogLayersListBinding>\r\n</igo-catalog-layers-list>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/lib/tool/tools/catalog-layers-tool/catalog-layers-tool.component.html
// module id = 1124
// module chunks = 0